import "./style.scss";

export const HeartBit = () => (
  <div className="heartbit bg-warning rounded-circle" />
);
